import { render, staticRenderFns } from "./commonFinishPaper.vue?vue&type=template&id=71d9428f&scoped=true&"
import script from "./commonFinishPaper.vue?vue&type=script&lang=js&"
export * from "./commonFinishPaper.vue?vue&type=script&lang=js&"
import style0 from "./commonFinishPaper.vue?vue&type=style&index=0&id=71d9428f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d9428f",
  null
  
)

export default component.exports